import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function AboutOlxGroup() {
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>About ClubLoop</h1>
          <p>
            ClubLoop is India's first dedicated online marketplace for pre-owned golf equipment.
            We connect the golfing community to buy smart, sell easy, and play more.
          </p>
        </div>

        <div className="infoSection">
          <h2>Our Mission</h2>
          <p>
            We are here to help golfers upgrade their game for less by making high-quality,
            second-hand golf equipment accessible, accurately valued, and completely secure to purchase online.
            By building transparency into the circular economy, we support men, women, and growing junior
            golfers across India with premium gear at a fraction of retail prices.
          </p>
        </div>

        <div className="infoSection">
          <h2>Our Core Pillars</h2>
          <p>
            ClubLoop delivers a trusted alternative to unverified local trading by embedding
            standardized checks and full buyer security directly into the user experience.
          </p>
          <div className="infoGrid">
            <div className="infoCard">
              <h3>Standardized Grading</h3>
              <p>Every club listed features a strict condition grade tag from A+ down to C so there are never any surprises.</p>
            </div>
            <div className="infoCard">
              <h3>Protected Escrow</h3>
              <p>For peer-to-peer trades, payments are held safely by ClubLoop until delivery and club condition are fully verified.</p>
            </div>
            <div className="infoCard">
              <h3>Dual Channels</h3>
              <p>Seamlessly browse through certified ClubLoop Stock or verified, individual golfer listings at fair market rates.</p>
            </div>
          </div>
        </div>

        <div className="infoSection">
          <h2>Our Values</h2>
          <ul>
            <li>
              <strong>Trust First:</strong> Eliminating scams and surprises through mandatory multi-point grading systems and secure payment holding.
            </li>
            <li>
              <strong>Community Focus:</strong> Empowering golf courses, pros, parents, and individual players to keep premium equipment in play.
            </li>
            <li>
              <strong>Mobile Simplicity:</strong> Crafting modern, fast, mobile-first design workflows that make listing gear on the course effortless.
            </li>
            <li>
              <strong>Sustainability:</strong> Reducing waste within the Indian sports ecosystem by ensuring high-performance gear finds a new home.
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutOlxGroup;
